import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { GrossQuantitySchema } from "../grossQuantitySchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { LoadingMaterialTable } from "../../../../Common/table";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import { red } from '@material-ui/core/colors';
import { Line, Circle } from 'rc-progress';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import { Height } from '@material-ui/icons';

const screenCode = 'GROSSQUANTITYWISEBAGCOUNTREPORT'

export function GrossQuantityWiseBagCount(props) {

    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        factoryID: "0",
        collectionPointID: "0",
        toDate: "",
        fromDate: "",
        minimumGrossQuantityID: "0"
    });
    const [searcheddata, setSearcheddata] = useState({
        route: "",
        toDate: "",
        fromDate: "",
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        operationEntity: "0",
        collectionPoint: "0",
        toDate: "",
        fromDate: "",
        minimumGrossQuantityID: "0"
    })
    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [900, 700],
    };
    const schema = Joi.object(GrossQuantitySchema).options({ allowUnknown: true });
    const contentRowNames = ["grossQuantity", "bagCount","percentage"]
    const csvHeaders = [
        { label: "Gross Quantity (Kg)", value: "grossQuantity" },
        { label: "Bag Count", value: "bagCount" },
        { label: "Percentage(%)", value: "percentage" },
    ];

    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const [bagTotal, setBagTotal] = useState(0);
    const [bagPercentage, setBagPercentage] = useState(0);

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [searchData.factoryID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGROSSQUANTITYWISEBAGCOUNTREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionPoint = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.factoryID);
        setCollectionPoint(collectionPoint);
    }


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, GrossQuantitySchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {
        e.preventDefault();


        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        let selectedValues = {
            group: parseInt(searchData.groupID),
            operationEntity: parseInt(searchData.factoryID),
            collectionPoint: parseInt(searchData.collectionPointID),
            toDate: searchData.toDate,
            fromDate: searchData.fromDate,
            minimumGrossQuantity: ((searchData.minimumGrossQuantityID == "0" || searchData.minimumGrossQuantityID == "" || searchData.minimumGrossQuantityID == null) ? null : searchData.minimumGrossQuantityID)

        }

        getSelectedDropdownValuesForReport(selectedValues);
        let result = await service.getReportData(selectedValues);

        const sumValues = [{
            route: collectionPoint[searchData.collectionPointID],
            fromDate: searchData.fromDate,
            toDate: searchData.toDate
        }];
        setSearcheddata(sumValues);
        var data = totalBagCount(result)

        result.forEach(x =>{
            x.percentage = ((x.bagCount/data)*100).toFixed(2);
        });
        setdata(result);

        setIsTableHide(false);

        setButtonHide(false);
        const completeData = [...result, ...sumValues];

        setCsvData(completeData);

    }


    function createFile() {
        var settings = {
            sheetName: 'Daily Collection Detailed',
            fileName: 'DailyCollectionDetailedReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.factoryID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
            minimumGrossQuantity: searchForm.minimumGrossQuantityID
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    function handleBars(data) {
        if (data != null) {
            var count = 0;
            for (const [grossQuantity, bagCount] of Object.entries(data)) {
                if (data.bagCount > 100) {
                    count = count + 1;

                }
            }

            if (count > 0) {
                for (const [grossQuantity, bagCount] of Object.entries(data)) {
                    return (<Line percent={(data.bagCount / 100) * 10} strokeWidth="4" strokeColor="green" trailColor="#D0F0C0"
                        strokeLinecap="round" trailWidth="4" />)
                }
            }
            else {
                for (const [grossQuantity, bagCount] of Object.entries(data)) {
                    return (<Line percent={(data.bagCount)} strokeWidth="4" strokeColor="green" trailColor="#D0F0C0"
                        strokeLinecap="round" trailWidth="4" />)
                } 
            }

        }
    }

    function totalBagCount(data){
        var total = 0;
        if(data!=null || data == undefined){
            data.forEach(element => {
                total += parseFloat(element.bagCount)  
              });
              setBagTotal(total);
            return total;
        }
        return 0;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div ref={pdfRef} className="card-body">
                        <div className="row">
                            <PageHeader
                                title="Gross Quantity-Wise Bag Count"
                                isButtonEnable={false}
                            />
                        </div>
                        <form >
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="groupID" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="factoryID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="factoryID"
                                        value={searchData.factoryID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["factoryID"] && <FormHelperText id="factoryID" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Route </InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Route--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date *"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date *"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">

                                    <TextField
                                        id="minimumGrossQuantityID"
                                        label="Minimum Gross Quantity"
                                        name="minimumGrossQuantityID"
                                        type="number"
                                        fullWidth
                                        value={searchData.minimumGrossQuantityID}
                                        onChange={(e) => handleChange(e)}

                                    />
                                    {errors["minimumGrossQuantityID"] && <FormHelperText id="minimumGrossQuantityID" className="text text-danger">{errors["minimumGrossQuantityID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                                <div className="row">

                                    <div className="col-md-12">


                                        <div className="paddingLeft">
                                            <div className="card col-md-12">
                                                <div className="row alternative_cls">
                                                    <div className="col width1"><b>Route: </b> {collectionPoint[searchData.collectionPointID] == undefined ? 'All' : collectionPoint[searchData.collectionPointID]}</div>
                                                    <div className="col width1"><b>From Date: </b> {selectedSearchValues.fromDate}</div>
                                                    <div className="col width1"><b>To Date: </b> {selectedSearchValues.toDate}</div>
                                                </div>
                                                <LoadingMaterialTable
                                                    title=""
                                                    columns={[
                                                        {
                                                            title: "Gross Quantity", field: "grossQuantity",
                                                            cellStyle: {
                                                                width: 10,
                                                                maxWidth:10,
                                                                textAlign: 'center',
    
                                                            },
                                                            headerStyle: {
                                                                width: 10,
                                                                maxWidth:10,
                                                                textAlign: 'center',
                                                                backgroundColor: '#ddd'
                                                            },

                                                        },
                                                        {
                                                            title: "Bag Count", field: "bagCount",
                                                            cellStyle: {
                                                                width: 10,
                                                                maxWidth: 10,
                                                                textAlign: 'center'
                                                            },
                                                            headerStyle: {
                                                                width: 10,
                                                                maxWidth: 10,
                                                                fontColor: red,
                                                                textAlign: 'center',
                                                                backgroundColor: '#ddd'
                                                            }
                                                        },
                                                        {
                                                            title: "Percentage(%)", field: "percentage",
                                                            cellStyle: {
                                                                width: 10,
                                                                maxWidth:10,
                                                                textAlign: 'center'
                                                            },
                                                            headerStyle: {
                                                                width: 10,
                                                                maxWidth: 10,
                                                                fontColor: red,
                                                                textAlign: 'center',
                                                                backgroundColor: '#ddd'
                                                            },
                                                        
                                                        },
                                                        {
                                                            title: "",
                                                            sortArrow: false,

                                                            render: (data => (

                                                                handleBars(data)

                                                            )),
                                                            cellStyle: {
                                                                width: 40,
                                                                maxWidth: 40,
                                                                textAlign: 'center'
                                                            },
                                                            headerStyle: {
                                                                width: 40,
                                                                maxWidth: 40,
                                                                fontColor: red,
                                                                textAlign: 'center',
                                                                backgroundColor: '#ddd'
                                                            }
                                                        },
                                                    ]}
                                                    data={data}
                                                    options={{
                                                        search: true,
                                                        paging: false
                                                    }}
                                                />
                                                <br/><br/>
                                                <div className="row alternative_cls">
                                                    <div className="col width1"><h6><b>Total Bag Count  :</b> {bagTotal}</h6></div>
                                            
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Gross Quantity-Wise Bag Count Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={data}
                                        rowNames={contentRowNames} searchData={searcheddata} bagTotal ={bagTotal}/>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



